// components/Pagination.jsx
import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Pagination = ({ currentPage, totalPages, hasNext, hasPrevious, onPageChange }) => {
  // Función para generar el rango de páginas a mostrar
  const generatePageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;
    
    if (totalPages <= maxPagesToShow) {
      // Si hay pocas páginas, mostrar todas
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Manejar casos con muchas páginas
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
      
      // Ajustar el rango si estamos cerca del final
      if (endPage - startPage < maxPagesToShow - 1) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }
      
      // Siempre mostrar la primera página
      if (startPage > 1) {
        pageNumbers.push(1);
        if (startPage > 2) {
          pageNumbers.push('...');
        }
      }
      
      // Agregar las páginas del rango principal
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
      
      // Siempre mostrar la última página
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pageNumbers.push('...');
        }
        pageNumbers.push(totalPages);
      }
    }
    
    return pageNumbers;
  };

  // Si solo hay una página, no mostrar la paginación
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex items-center justify-center">
      {/* Botón anterior */}
      <button
        onClick={() => hasPrevious && onPageChange(currentPage - 1)}
        disabled={!hasPrevious}
        className={`flex items-center justify-center w-10 h-10 rounded-full ${
          hasPrevious 
            ? 'bg-zinc-800 text-white hover:bg-red-600 transition-colors' 
            : 'bg-zinc-800/50 text-gray-500 cursor-not-allowed'
        }`}
        aria-label="Página anterior"
      >
        <FaChevronLeft className="text-sm" />
      </button>
      
      {/* Botones de página */}
      <div className="mx-2 flex items-center space-x-1">
        {generatePageNumbers().map((page, index) => (
          page === '...' ? (
            <span key={`ellipsis-${index}`} className="w-10 h-10 flex items-center justify-center text-gray-400">
              ...
            </span>
          ) : (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`w-10 h-10 rounded-full flex items-center justify-center ${
                currentPage === page
                  ? 'bg-red-600 text-white'
                  : 'bg-zinc-800 text-white hover:bg-zinc-700 transition-colors'
              }`}
            >
              {page}
            </button>
          )
        ))}
      </div>
      
      {/* Botón siguiente */}
      <button
        onClick={() => hasNext && onPageChange(currentPage + 1)}
        disabled={!hasNext}
        className={`flex items-center justify-center w-10 h-10 rounded-full ${
          hasNext 
            ? 'bg-zinc-800 text-white hover:bg-red-600 transition-colors' 
            : 'bg-zinc-800/50 text-gray-500 cursor-not-allowed'
        }`}
        aria-label="Página siguiente"
      >
        <FaChevronRight className="text-sm" />
      </button>
    </div>
  );
};

export default Pagination;